<template>
  <CRow>
    <CCol md="12" style="font-size: 14px; margin-bottom: 80px;">
      <CDataTable
        :items="items"
        :fields="fields"
        :items-per-page="20"
        hover
        striped
        border
        small
        fixed
        pagination
        :noItemsView="{ noResults: 'No se encontraron envios', noItems: 'No hay envios programados' }"
      >
        <template #position="{ index }">
          <td class="text-center">{{ index + 1 }}</td>
        </template>

        <template #message_type="{ item }">
          <td class="text-center">{{ getTypeLabel(item.message_type) }}</td>
        </template>

        <template #scheduled_date="{ item }">
          <td class="text-center">{{ item.scheduled_date | date }}</td>
        </template>

        <template #scheduled_time="{ item }">
          <td class="text-center">{{ formatTime(item.scheduled_time) }}</td>
        </template>

        <template #status="{ item }">
          <td class="text-center">
            <span :class="['wa-badge', 'wa-badge--' + item.status]">{{ getStatusLabel(item.status) }}</span>
          </td>
        </template>

        <template #actions="{ item }">
          <td class="text-center">
            <CButton color="info" size="sm" @click="$emit('show-detail', item)">
              <CIcon name="cil-list-rich" />
            </CButton>
            <CButton
              v-if="canEdit(item)"
              color="warning"
              size="sm"
              class="ml-1"
              @click="$emit('edit', item)"
            >
              <CIcon name="cil-pencil" />
            </CButton>
            <CButton
              v-if="canCancel(item)"
              color="dark"
              size="sm"
              class="ml-1"
              @click="$emit('cancel', item)"
            >
              <CIcon name="cil-x-circle" />
            </CButton>
            <CButton
              v-if="canExecute(item)"
              color="success"
              size="sm"
              class="ml-1"
              @click="$emit('execute-now', item)"
            >
              <CIcon name="cil-check-circle" />
            </CButton>
          </td>
        </template>
      </CDataTable>
    </CCol>
  </CRow>
</template>

<script>
import useMessageTypeLabel from '@/composables/useMessageTypeLabel'

const { getMessageTypeLabel } = useMessageTypeLabel()

export default {
  name: 'ScheduledSendsTable',
  props: {
    items: { type: Array, required: true }
  },
  computed: {
    fields() {
      return [
        { key: 'position', label: 'N°', _style: 'width: 50px;' },
        { key: 'message_type', label: 'Tipo', _style: 'width: 140px;' },
        { key: 'scheduled_date', label: 'Fecha', _style: 'width: 140px;' },
        { key: 'scheduled_time', label: 'Hora', _style: 'width: 90px;' },
        { key: 'recipient_count', label: 'Destinatarios', _style: 'width: 110px;' },
        { key: 'status', label: 'Estado', _style: 'width: 110px;' },
        { key: 'actions', label: 'Acciones', _style: 'width: 190px;' },
      ]
    }
  },
  methods: {
    canEdit(item) {
      return ['scheduled', 'failed'].includes(item.status)
    },
    canCancel(item) {
      return ['scheduled', 'failed'].includes(item.status)
    },
    canExecute(item) {
      return ['scheduled', 'failed'].includes(item.status)
    },
    getTypeLabel(type) {
      return getMessageTypeLabel(type)
    },
    getStatusLabel(status) {
      switch (status) {
        case 'scheduled': return 'Programado'
        case 'executing': return 'Ejecutando'
        case 'queued': return 'En cola'
        case 'executed': return 'Ejecutado'
        case 'cancelled': return 'Cancelado'
        case 'failed': return 'Error'
        default: return status
      }
    },
    formatTime(value) {
      if (!value) return ''
      return String(value).substring(0, 5)
    }
  }
}
</script>

<style scoped>
.wa-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.wa-badge--scheduled {
  background: #fff3cd;
  color: #856404;
}

.wa-badge--executing,
.wa-badge--queued {
  background: #cce5ff;
  color: #004085;
}

.wa-badge--executed {
  background: #d4edda;
  color: #155724;
}

.wa-badge--cancelled,
.wa-badge--failed {
  background: #f8d7da;
  color: #721c24;
}
</style>
